module.exports = __webpack_public_path__ + "static/media/s29ru.b485dbd5.pdf";